(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  class TabsSection {
    constructor(container) {
      this.container = container;
      this.tabList = container.querySelector('[role="tablist"]');
      this.tabs = Array.from(container.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));
      
      this.bindEvents();
    }

    bindEvents() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
        tab.addEventListener('keydown', (e) => this.handleTabKeydown(e));
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const panelIndex = parseInt(tab.dataset.panelIndex);
      this.activateTab(panelIndex);
    }

    handleTabKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex = currentIndex;

      switch(event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabs.length - 1;
          event.preventDefault();
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          newIndex = currentIndex < this.tabs.length - 1 ? currentIndex + 1 : 0;
          event.preventDefault();
          break;
        case 'Home':
          newIndex = 0;
          event.preventDefault();
          break;
        case 'End':
          newIndex = this.tabs.length - 1;
          event.preventDefault();
          break;
        case 'Enter':
        case ' ':
          this.activateTab(currentIndex);
          event.preventDefault();
          break;
        default:
          return;
      }

      if (newIndex !== currentIndex) {
        this.tabs[newIndex].focus();
        this.activateTab(newIndex);
      }
    }

    activateTab(index) {
      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.setAttribute('aria-selected', isActive);
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('active', isActive);
        panel.setAttribute('aria-hidden', !isActive);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tabs-section-wrapper').forEach(container => {
      new TabsSection(container);
    });
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('.tabs-section-wrapper');
      if (container) {
        new TabsSection(container);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
